import { companyHeroCopy } from '../content/companyHomeContent.js';
import type { LandingContent, LandingLocale } from '../content/landingContentTypes.js';
import type { LandingEditorElementFrame } from './landingEditorTypes.js';

/** Copy into the new namespace once. The complete old hero remains the archive. */
export const migrateCompanyPeopleHeroContent = (content: LandingContent, locale: LandingLocale): void => {
  const previous = content.companyPlatformHero;
  const next = content.companyPeopleHero;
  next.title = previous.title;
  next.highlight = previous.highlight;
  if (previous.intro !== companyHeroCopy[locale].intro) next.intro = previous.intro;
  next.portrait = { ...previous.portraits.second };
  next.primaryAction = { ...previous.primaryAction };
  next.secondaryAction = { ...previous.secondaryAction };
  next.benefits = previous.benefits.map(benefit => ({ ...benefit }));
};

/** Preserve visibility without applying geometry from a different composition. */
export const migrateCompanyPeopleHeroVisibility = (frames: Record<string, LandingEditorElementFrame>): void => {
  const migrated = new Map<string, boolean>();
  for (const [id, frame] of Object.entries(frames)) {
    if (!id.startsWith('companyPlatformHero.') && id !== 'section.companyPlatformHero') continue;
    if (id.includes('.matching.') || id.includes('.demo')) continue;
    if (frame.hidden === undefined) continue;
    const nextId = id
      .replace('companyPlatformHero.portraits.second', 'companyPeopleHero.portrait')
      .replace('companyPlatformHero.portraits', 'companyPeopleHero.contact')
      .replace('companyPlatformHero.visual', 'companyPeopleHero.benefits')
      .replace('companyPlatformHero', 'companyPeopleHero');
    const targets = [nextId];
    if (id === 'companyPlatformHero.copy' && frame.hidden) targets.push('companyPeopleHero.contact');
    if (id === 'companyPlatformHero.portraits' && frame.hidden) targets.push('companyPeopleHero.intro');
    for (const target of targets) migrated.set(target, Boolean(migrated.get(target) || frame.hidden));
  }
  for (const [id, hidden] of migrated) if (!frames[id]) frames[id] = { x: 0, y: 0, hidden };
};
